/* eslint-disable */
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Spin,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
} from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

function useLazySelect(apiUrl, key, mapper, enableCache = true) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (enableCache && loaded) return;
    setLoading(true);
    try {
      const res = await http.get(apiUrl);
      const list = res?.data?.[key] || res?.data || [];
      setOptions(mapper(list));
      setLoaded(true);
    } catch (err) {
      console.error("Select load error:", err);
    } finally {
      setLoading(false);
    }
  };

  return { options, loading, load };
}

const ResetModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openLoading, setOpenLoading] = useState(false); 
  const [currentId, setCurrentId] = useState(null);

  // const stateSelect = useLazySelect(
  //   api.getStateDictList,
  //   "state",
  //   (data) => data.map((s) => ({ label: s, value: s }))
  // );
    const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
    Object.entries(data || {}).map(([key, label]) => ({
      label,   
      value: key, 
    })),
  );
  useImperativeHandle(ref, () => ({
    open: async (record) => {
      const id = record?.groupId;
      if (!id) {
        message.error("Invalid GroupId");
        return;
      }

      setCurrentId(id);
      setVisible(true);
      setOpenLoading(true);
      form.resetFields();

      try {
        await stateSelect.load();

        const res = await http.get(api.getGroupById, {
          params: { groupId: id },
        });
        const data = res?.data?.data;

        if (!data) {
          message.error("Failed to parse group data");
          return;
        }

      
        form.setFieldsValue(data);

      } catch (err) {
        console.error("Load group data failed:", err);
        message.error("Failed to load group data");
      }

      setOpenLoading(false);
    },
  }));

  /* ---------------------------- 提交更新 ---------------------------- */
  const onFinish = async (values) => {
    setLoading(true);

    try {
      const params = { ...values, groupId: currentId };

      const res = await http.post(api.getGroupUpdate, params);

      if (res.code === "1") {
        message.success("Group Updated Successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg || "Update failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            EDIT GROUP
          </Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={
           <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            {openLoading ? (
              <Flex justify="center" align="center" style={{ height: 200 }}>
                <Spin size="large" />
              </Flex>
            ) : (
              <Form
                form={form}
                name="editGroupForm"
                layout="horizontal"
                labelCol={{ style: { width: "200px" } }}
                wrapperCol={{ style: { flex: 1 } }}
                onFinish={onFinish}
              >
                <Flex align="flex-start" justify="space-between" gap={32}>
                  <div style={{ flex: 1 }}>
                    <div className="modal-section-title">
                      <BankOutlined /> Group Information
                    </div>

                    <Form.Item
                      name="groupCode"
                      label="Group Code"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Group Code" />
                    </Form.Item>

                    <Form.Item
                      name="groupName"
                      label="Group Name"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Group Name" />
                    </Form.Item>

                    <Form.Item
                      name="street"
                      label="Street"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Street" />
                    </Form.Item>

                    <Form.Item
                      name="city"
                      label="City"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="City" />
                    </Form.Item>

                    <Form.Item
                      name="county"
                      label="County"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="County" />
                    </Form.Item>

                    <Form.Item
                      name="zip"
                      label="Zip"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Zip" />
                    </Form.Item>

                    <Form.Item
                      name="state"
                      label="State"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Select State"
                        loading={stateSelect.loading}
                        options={stateSelect.options}
                      />
                    </Form.Item>

                    <Form.Item name="phone" label="Phone">
                      <Input placeholder="Phone" />
                    </Form.Item>

                    <Form.Item name="officeHour" label="Office Hours">
                      <Input placeholder="Office Hours" />
                    </Form.Item>
                  </div>
                </Flex>
              </Form>
            )}
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default ResetModal;
